exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".divider--1tVnu{border-left:1px solid #eee;margin:10px}@media(max-width:767px){.divider--1tVnu{display:none}}.sliderDivider--1KOfi{border-left:1px solid #eee;margin:10px;height:59px}", ""]);

// Exports
exports.locals = {
	"divider": "divider--1tVnu",
	"sliderDivider": "sliderDivider--1KOfi"
};